<template>
    <t-space direction="vertical" style="width: 100%;" size="small">
        <!-- <t-space></t-space> -->
        <t-row style="width: 100%;" :gutter="14.8">
                <t-col></t-col>
                <t-col>
                    <t-card bordered :style="{ width: '13.1vw',background:'linear-gradient(to right, #62ABFD, #9E80F3)',color: '#ffffff'}" title="库存总价值">
                        <t-space :size="120" align="center">
                            <t-statistic :value="total_value" :loading="false" unit="元"/>
                        </t-space>
                    </t-card>
                </t-col>
                <t-col >
                    <t-card bordered :style="{ width: '13.1vw',background:'linear-gradient(to right, #77EFD8, #45BAF2)'}" title="总出库量">
                        <t-space :size="120" align="center">
                            <t-statistic  :value="output_amount" :loading="false" unit="笔"/>
                        </t-space>
                    </t-card>
                </t-col>
                <t-col >
                    <t-card bordered :style="{ width: '13.1vw',background:'linear-gradient(to right, #F9BF66, #F95C81)'}" title="总入库量">
                        <t-space :size="120" align="center">
                            <t-statistic  :value="input_amount" :loading="false" unit="笔"/>
                        </t-space>
                    </t-card>
                </t-col>
                <t-col>
                    <t-card bordered :style="{ width: '13.1vw',background:'linear-gradient(to right, #B687FB, #F5ACCC)'}" title="维护总成本">
                        <t-space :size="120" align="center">
                            <t-statistic  :value="total_cost" :loading="false" unit="元"/>
                        </t-space>
                    </t-card>
                </t-col>
                <t-col>
                    <t-card bordered :style="{ width: '13.1vw',background:'linear-gradient(to right, #FFE35A, #FFB064)'}" title="待收总额">
                        <t-space :size="120" align="center">
                            <t-statistic  :value="should_receive" :loading="false" unit="元"/>
                        </t-space>
                    </t-card>
                </t-col>
                <t-col>
                    <t-card bordered :style="{ width: '13.1vw',background:'linear-gradient(to right, #ff7e5f, #feb47b)'}" title="待付总额">
                        <t-space :size="120" align="center">
                            <t-statistic  :value="should_pay" :loading="false" unit="元"/>
                        </t-space>
                    </t-card>
                </t-col>
        </t-row>
        <t-row style="width: 100%;"  :gutter="16">
                <t-col></t-col>
                <t-col>
                    <t-card bordered :style="{ width: '61.8vw',height: '39vh' }" title="本周的库存价值增量走势">
                        <div ref="table" style="width: 100%; height: 30vh;"></div>
                    </t-card>
                </t-col>
                <t-col>
                    <t-card bordered :style="{ width: '20vw',height: '39vh' }" title="仓库货物所有类别分布占比">
                        <div v-show="haveDataForPie" ref="channel_of_distribution"  style="width: 100%; height: 30vh;"></div>
                        <t-empty type="empty" :size="size" v-if="!haveDataForPie" style="margin-top: 10vh;"></t-empty>
                    </t-card>
                </t-col>
                <t-col></t-col>
        </t-row>
        <t-row style="width: 100%;"  :gutter="16">
                <t-col></t-col>
                <t-col>
                    <t-card bordered :style="{ width: '82.7vw' }" title="出入库概况">
                        <div ref="warehouse_status"  style="width: 100%; height: 23vh;"></div>
                    </t-card>
                </t-col>
                <t-col>
                </t-col>
                <t-col></t-col>
        </t-row>
    </t-space>
</template>

<script setup lang="jsx">
import * as echarts from 'echarts';
import { ref, onMounted} from 'vue';

import {NotifyPlugin} from 'tdesign-vue-next'
import request from '@/request/request'


const haveDataForPie = ref(true)

const table = ref(null);
const channel_of_distribution = ref(null)
const warehouse_status = ref(null)
const total_value = ref(0)
const output_amount = ref(0)
const input_amount = ref(0)
const total_cost = ref(0)
const should_pay = ref(0)
const should_receive = ref(0)

const getStartAndEndOfWeek = ()=> {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 获取今天是星期几，0 表示星期日，1 表示星期一，依此类推
    // 计算本周第一天（星期一）的日期
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
    // 计算本周最后一天（星期日）的日期
    const endOfWeek = new Date(today);
    endOfWeek.setDate(today.getDate() - dayOfWeek + 7);
    return {
        startOfWeek: startOfWeek.toISOString().split('T')[0], // 格式化为 YYYY-MM-DD
        endOfWeek: endOfWeek.toISOString().split('T')[0]    // 格式化为 YYYY-MM-DD
    };
}

const getWeekDates = () => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 获取今天是星期几，0 表示星期日，1 表示星期一，依此类推
    // 计算本周第一天（星期一）的日期
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));

    const weekDates = [];
    for (let i = 0; i < 7; i++) {
        const date = new Date(startOfWeek);
        date.setDate(date.getDate() + i); // 修正这里
        weekDates.push(date.toISOString().split('T')[0]); // 格式化为 YYYY-MM-DD
    }
    return weekDates;
};
const InitData = () =>{
    const call_err = (err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '获取数据失败.' + err,
        })
    }
    request.BIgetTotalValue((res)=>{
        if(res.data.success) {
            total_value.value =  parseFloat(res.data.data).toFixed(2);
        }else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '数据请求错误',
                content: '数据请求失败，其联系管理人员',
                duration: 3000,
            })
        }
    },call_err)
    request.BIgetOutputAmount((res)=>{
        if(res.data.success) {
            output_amount.value = res.data.data
        }else{
            NotifyPlugin.error({
                placement: 'top-right',
                title: '数据请求错误',
                content: '数据请求失败，其联系管理人员',
                duration: 3000,
            })
        }
    },call_err)
    request.BIgetInputAmount((res)=>{
        if(res.data.success) {
            input_amount.value = res.data.data
        }else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '数据请求错误',
                content: '数据请求失败，其联系管理人员',
                duration: 3000,
            })
        }
    },call_err)
    request.BIgetTotalCost((res)=>{
        if(res.data.success) {
            total_cost.value =  parseFloat(res.data.data).toFixed(2);
        }else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '数据请求错误',
                content: '数据请求失败，其联系管理人员',
                duration: 3000,
            })
        }
    },call_err)
    request.RequestQueryWarehouseInfo(0,10,null,(res)=>{
        if(res.data.success) {
            let data_list = []
            let name_list = []
            // alert(res.data.data == 0)
            if(res.data.data == 0) {
                haveDataForPie.value = false
                return
            }
            for(let i = 0;i < res.data.data.length;i++) {
                let info = {}
                info.name = res.data.data[i].warehouseName
                info.value = 0
                data_list[i] = info
                let name = res.data.data[i].warehouseName
                name_list[i] = name
                request.RequestWarehouseGoodsInfoAmount(res.data.data[i].warehouseId,(res)=>{
                    if(res.data.success) {
                        info.value = res.data.data
                        InitPieChart(name_list,data_list)
                        haveDataForPie.value = true
                    }else {
                        haveDataForPie.value = false
                    }
                },()=>{haveDataForPie.value = false} )
            }
        } else {
            haveDataForPie.value = false
            NotifyPlugin.error({
                placement: 'top-right',
                title: '数据请求错误',
                content: '数据请求失败，其联系管理人员',
                duration: 3000,
            })
        }
    },call_err)
    let time = getStartAndEndOfWeek()
    request.BIGetIoDoubleLine(time.startOfWeek,time.endOfWeek,(res)=>{
        if(res.data.success) {
            InitLineChart(getWeekDates(),res.data.data)
        }
    },(err)=>{
        console.log(err)
    })

    request.BIgetInputAmountOnPassTime(time.startOfWeek,time.endOfWeek,(res)=>{
        if( res.data.success) {
            let inputDataList = res.data.data
            request.BIgetOutputAmountOnPassTime(time.startOfWeek,time.endOfWeek,(res)=>{
                if(res.data.success) {
                    let outputDataList = res.data.data
                    InitBarChart(getWeekDates(),inputDataList,outputDataList)
                }
            },call_err)
        }
    },call_err)
    request.RequestShouldReceive(parseInt(sessionStorage.getItem("user_id")),(res)=>{
        if(res.data.success) {
            should_receive.value = parseFloat(res.data.data).toFixed(2);
        }else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '数据请求错误',
                content: '数据请求失败，其联系管理人员',
                duration: 3000,
            })
        }
    },call_err)
    request.RequestShouldPay(parseInt(sessionStorage.getItem("user_id")),(res)=>{
        if(res.data.success) {
            should_pay.value = parseFloat(res.data.data).toFixed(2);
        }else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '数据请求错误',
                content: '数据请求失败，其联系管理人员',
                duration: 3000,
            })
        }
    },call_err)
}

const InitBarChart = (name_list,data_list1,data_list2)=>{
    // haveDataForPie.value = true
    let warehouse_status_impl = echarts.init(warehouse_status.value);
    warehouse_status_impl.setOption({
        tooltip: {
            trigger: 'axis', // 触发类型为坐标轴触发
            axisPointer: {
                type: 'shadow' // 使用阴影指示器
            },
            formatter: function (params) {
                let tooltip = params[0].name + '<br/>';
                params.forEach(param => {
                    tooltip += `${param.seriesName}: ${param.value}<br/>`;
                });
                return tooltip;
            }
        },
        legend: {
            // orient: 'vertical',
            x: 'left',
            data: ["出库量","入库量"]
        },
        xAxis: {
            data: name_list
        },
        yAxis: {},
        series: [
            {
                name: "入库量",
                type: 'bar',
                data: data_list1,
                barWidth: '20%'
            },
            {
                name: "出库量",
                type: 'bar',
                data: data_list2,
                barWidth: '20%'
            }
        ]
    })
}
const InitLineChart = (xAxis_data,series_data) => {
    let table_impl = echarts.init(table.value);
    table_impl.setOption(
        {
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['出库金额总量', '入库金额总量']
            },
            xAxis: {
                data: xAxis_data,
                showSymbol: false,
            },
            yAxis: {},
            series: [
                {
                    name: "出库金额总量",
                    data: series_data.output,
                    type: 'line',
                    smooth: true,
                    areaStyle: {}
                },
                {
                    name:"入库金额总量",
                    data: series_data.input,
                    type: 'line',
                    smooth: true,
                    areaStyle: {}
                },
            ]
        }
    )
}
const InitPieChart = (name_list,data_list) =>{
    let channel_of_distribution_impl = echarts.init(channel_of_distribution.value);
    channel_of_distribution_impl.setOption({
        legend: {
            // orient: 'vertical',
            x: 'left',
            data: name_list
        },
        series: [
            {
                type: 'pie',
                radius: ['50%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                labelLine: {
                    show: false
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: '30',
                        // fontWeight: 'bold',
                        formatter: '种类数:{c}' // 显示名称和具体值
                    }
                },
                data: data_list
            }
        ]
    })
}
onMounted(()=>{
    InitData()
})

</script>

<style scoped>

</style>
